import { wencesApi } from "@/api/wencesApi";

export default async function isAdminGuard(to, from, next) {
  console.log("Starting admin guard check...");
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      console.log("No token found");
      next(false);
      return false;
    }

    // Obtener el perfil del usuario
    console.log("Fetching user profile...");
    const profileResponse = await wencesApi.get("/api/users/myprofile", {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log(
      "User profile response:",
      JSON.stringify(profileResponse.data, null, 2)
    );

    if (!profileResponse.data.ok) {
      console.log("Error in profile response");
      next(false);
      return false;
    }

    const userData = profileResponse.data.data;
    console.log("User data:", JSON.stringify(userData, null, 2));
    let roleId;

    // Obtener el ID del rol
    if (typeof userData.role === "string") {
      roleId = userData.role;
      console.log("Role ID from string:", roleId);
    } else if (userData.role && userData.role._id) {
      roleId = userData.role._id;
      console.log("Role ID from object:", roleId);
    }

    console.log("Final Role ID:", roleId);

    if (!roleId) {
      console.log("No role ID found");
      next(false);
      return false;
    }

    // Obtener los permisos del rol
    console.log("Fetching role permissions...");
    const roleResponse = await wencesApi.get(`/api/roles/${roleId}`);
    console.log("Role response:", JSON.stringify(roleResponse.data, null, 2));

    // Verificar si la respuesta tiene la estructura correcta
    if (
      roleResponse.data &&
      roleResponse.data.success &&
      roleResponse.data.data &&
      Array.isArray(roleResponse.data.data.permissions)
    ) {
      const permissions = roleResponse.data.data.permissions;
      console.log("User permissions:", permissions);
      console.log(
        "Checking for all_access:",
        permissions.includes("all_access")
      );
      console.log(
        "Checking for settings_manage:",
        permissions.includes("settings_manage")
      );

      // Verificar si el usuario tiene los permisos necesarios
      const hasRequiredPermissions =
        permissions.includes("all_access") ||
        permissions.includes("settings_manage");
      console.log("Has required permissions:", hasRequiredPermissions);

      if (hasRequiredPermissions) {
        console.log("User has required permissions");
        next();
        return;
      } else {
        console.log(
          "User does not have required permissions. Available permissions:",
          permissions
        );
      }
    } else {
      console.log("Invalid role response structure:", roleResponse.data);
    }

    console.log("Access denied, redirecting to dashboard");
    next("/dashboard");
    return;
  } catch (error) {
    console.error("Error in admin guard:", error);
    console.error("Error details:", error.response?.data);
    next("/dashboard");
    return;
  }
}
